import { Component, HostListener, Input } from '@angular/core';
import { faExpand, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  CommunicationAttachment,
  CommunicationMediaKind,
} from '../../services/communications/models';

@Component({
  selector: 'ng-casto-communication-media-gallery',
  templateUrl: './communication-media-gallery.component.html',
  styleUrl: './communication-media-gallery.component.scss',
})
export class CommunicationMediaGalleryComponent {
  @Input() attachments: readonly CommunicationAttachment[] = [];

  protected selectedAttachment: CommunicationAttachment | null = null;
  protected readonly CommunicationMediaKind = CommunicationMediaKind;
  protected readonly faExpand = faExpand;
  protected readonly faTimes = faTimes;

  private viewerTrigger: HTMLElement | null = null;

  protected openFullscreen(attachment: CommunicationAttachment, event: Event): void {
    this.viewerTrigger = event.currentTarget as HTMLElement;
    this.selectedAttachment = attachment;
  }

  protected closeFullscreen(): void {
    if (!this.selectedAttachment) return;

    const trigger = this.viewerTrigger;
    this.selectedAttachment = null;
    this.viewerTrigger = null;
    queueMicrotask(() => trigger?.focus());
  }

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    this.closeFullscreen();
  }
}
